import { Observable } from 'rxjs'

export interface DirtyFormCanDeactivateGuard {
  isDirty(): boolean

  /**
   * Ask the user if they want to discard the form
   * @returns Observable<boolean> - true if the user wants to discard the form, false otherwise
   */
  askToDiscardForm(): Observable<boolean>
}

/**
 * Verhindet das verlassen einer Komponente wenn das Formular dirty ist.
 * Der Benutzer wird gefragt ob er das Formular verwerfen möchte.
 *
 * @example @see LeistungserbringerVerwaltungComponent
 */
export function canDeactivateDirtyFormGuard(component: DirtyFormCanDeactivateGuard) {
  if (!component.isDirty()) {
    return true
  }
  // Aufruf an der Componente um das Eager Loading vom MatDialog (~80kb) zu verhindern.
  // @see DirtyFormCanDeactivateGuardAdapter
  return component.askToDiscardForm()
}
